module.exports = __webpack_public_path__ + "img/CSAT5.f21ca5bc.svg";